import { FC, ReactNode, useEffect } from "react";

import __ from "web/Layout/Translations";

import Title from "web/Components/Common/Title/title";

import Check from "web/assets/icons/ik_check_surcharge.svg";

import { Classes } from "web/types/Common";
import { Nullable } from "web/types/Utils";

import classify from "web/classify";

import defaultClasses from "./modalNotification.scss";

interface IModalNotificationProps {
  textInfo?: string;
  classes?: Classes;
  timer?: NodeJS.Timeout;
  component?: ReactNode;
  onCloseModal?: Nullable<() => void>;
}

const ModalNotification: FC<IModalNotificationProps> = ({
  textInfo = null,
  classes = {},
  timer = null,
  component = null,
  onCloseModal = null,
}) => {
  useEffect(() => {
    return () => {
      if (timer) window.clearTimeout(timer);
      if (onCloseModal) onCloseModal();
    };
  });

  return (
    <div className={classes.root}>
      {textInfo && (
        <Title
          name={
            <>
              <Check className={classes.titleIcon} />
              <span>{__(textInfo)}</span>
            </>
          }
          isCentered
        />
      )}
      {component}
    </div>
  );
};

export default classify<IModalNotificationProps>(defaultClasses)(
  ModalNotification
);
